import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { isArray } from 'lodash';
import qs from 'qs';
import { api } from '.';
import { handleServerCoverageListData } from '../utils/coverage';
import { handleRequestError } from '../utils/request';
/**
 * Create organization supplier
 */

export var apiCreateOrganizationSupplier = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.post("/msp/".concat(payload.organizationId, "/invitations"), payload);

          case 3:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function apiCreateOrganizationSupplier(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Query organization supplier detail info
 */

export var apiQueryOrganizationSupplierDetailInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.get("/msp/supplier/".concat(payload.supplierId), {
              params: {
                token: payload === null || payload === void 0 ? void 0 : payload.token
              }
            });

          case 3:
            res = _context2.sent;

            if (res.data) {
              res.data.contract_requirements_by_country = (res.data.contract_requirements_by_country || []).map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  coverages: handleServerCoverageListData(item.coverages)
                });
              });
              res.data.supplier_subsidiaries = (res.data.supplier_subsidiaries || []).map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  value: item.id,
                  label: item.name
                });
              });
            }

            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function apiQueryOrganizationSupplierDetailInfo(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Query organization supplier company list
 */

export var apiQueryOrganizationSupplierCompanyList = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var _res$data, _res$data2, res;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.get("/msp/supplier/company?".concat(qs.stringify(payload)));

          case 3:
            res = _context3.sent;

            if (res !== null && res !== void 0 && res.data && !((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.company_list)) {
              res.data.company_list = [];
            }

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.company_list)) {
              res.data.company_list.forEach(function (item) {
                item.company = item.id = item.company_id;
              });
            }

            return _context3.abrupt("return", [res.data]);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0, payload));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 9]]);
  }));

  return function apiQueryOrganizationSupplierCompanyList(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Update/Add organization supplier company
 */

export var apiUpdateOrganizationSupplierCompanyInfo = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.patch("/msp/supplier/company/country", payload);

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data]);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0, payload));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function apiUpdateOrganizationSupplierCompanyInfo(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * Delete organization supplier company
 */

export var apiDeleteOrganizationSupplierCompany = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api["delete"]("/msp/supplier/company?".concat(qs.stringify(payload)));

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data]);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0, payload));

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function apiDeleteOrganizationSupplierCompany(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * Update organization supplier info
 */

export var apiUpdateOrganizationSupplierInfo = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.patch("/msp/supplier/".concat(payload.supplierId, "?").concat(qs.stringify({
              token: payload === null || payload === void 0 ? void 0 : payload.token
            })), payload);

          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", [res.data]);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0, payload));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));

  return function apiUpdateOrganizationSupplierInfo(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * Update organization supplier region requirement
 */

export var apiUpdateOrganizationSupplierRegionRequirement = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return api.patch("/msp/supplier/".concat(payload.supplier_id, "/contract_requirement"), payload);

          case 3:
            res = _context7.sent;
            return _context7.abrupt("return", [res.data]);

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", handleRequestError(_context7.t0, payload));

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 7]]);
  }));

  return function apiUpdateOrganizationSupplierRegionRequirement(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * Delete organization supplier region requirement
 */

export var apiDeleteOrganizationSupplierRegionRequirement = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return api["delete"]("/msp/supplier/".concat(payload.supplier_id, "/contract_requirement?").concat(qs.stringify(payload)));

          case 3:
            res = _context8.sent;
            return _context8.abrupt("return", [res.data]);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", handleRequestError(_context8.t0, payload));

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));

  return function apiDeleteOrganizationSupplierRegionRequirement(_x8) {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * Add organization supplier region requirement
 */

export var apiAddOrganizationSupplierRegionRequirement = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return api.post("/msp/supplier/".concat(payload.supplier_id, "/contract_requirement"), payload);

          case 3:
            res = _context9.sent;
            return _context9.abrupt("return", [res.data]);

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);
            return _context9.abrupt("return", handleRequestError(_context9.t0, payload));

          case 10:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 7]]);
  }));

  return function apiAddOrganizationSupplierRegionRequirement(_x9) {
    return _ref9.apply(this, arguments);
  };
}();
/**
 * Query organization supplier country-company list
 */

export var apiQueryOrganizationSupplierCountryCompanyList = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return api.get("/msp/supplier/country?".concat(qs.stringify(payload)));

          case 3:
            res = _context10.sent;
            return _context10.abrupt("return", [res.data]);

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](0);
            return _context10.abrupt("return", handleRequestError(_context10.t0, payload));

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 7]]);
  }));

  return function apiQueryOrganizationSupplierCountryCompanyList(_x10) {
    return _ref10.apply(this, arguments);
  };
}();
/**
 * Delete organization supplier country
 */

export var apiDeleteOrganizationSupplierCountry = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return api["delete"]("/msp/supplier/country?".concat(qs.stringify(payload)));

          case 3:
            res = _context11.sent;
            return _context11.abrupt("return", [res.data]);

          case 7:
            _context11.prev = 7;
            _context11.t0 = _context11["catch"](0);
            return _context11.abrupt("return", handleRequestError(_context11.t0, payload));

          case 10:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 7]]);
  }));

  return function apiDeleteOrganizationSupplierCountry(_x11) {
    return _ref11.apply(this, arguments);
  };
}();
/**
 * Update/Add organization supplier country
 */

export var apiUpdateOrganizationSupplierCountryInfo = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return api.patch("/msp/supplier/country/company", payload);

          case 3:
            res = _context12.sent;
            return _context12.abrupt("return", [res.data]);

          case 7:
            _context12.prev = 7;
            _context12.t0 = _context12["catch"](0);
            return _context12.abrupt("return", handleRequestError(_context12.t0, payload));

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 7]]);
  }));

  return function apiUpdateOrganizationSupplierCountryInfo(_x12) {
    return _ref12.apply(this, arguments);
  };
}();
export var apiCreateOrganizationSubsidiary = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return api.post("/organization_subsidiary", payload);

          case 3:
            res = _context13.sent;
            return _context13.abrupt("return", [res.data]);

          case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](0);
            return _context13.abrupt("return", handleRequestError(_context13.t0, payload));

          case 10:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 7]]);
  }));

  return function apiCreateOrganizationSubsidiary(_x13) {
    return _ref13.apply(this, arguments);
  };
}();
export var apiUpdateOrganizationSubsidiary = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return api.patch("/organization_subsidiary", payload);

          case 3:
            res = _context14.sent;
            return _context14.abrupt("return", [res.data]);

          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](0);
            return _context14.abrupt("return", handleRequestError(_context14.t0, payload));

          case 10:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 7]]);
  }));

  return function apiUpdateOrganizationSubsidiary(_x14) {
    return _ref14.apply(this, arguments);
  };
}();
export var apiDeleteOrganizationSubsidiary = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return api["delete"]("/organization_subsidiary/".concat(payload.subsidiary_id));

          case 3:
            res = _context15.sent;
            return _context15.abrupt("return", [res.data]);

          case 7:
            _context15.prev = 7;
            _context15.t0 = _context15["catch"](0);
            return _context15.abrupt("return", handleRequestError(_context15.t0, payload));

          case 10:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 7]]);
  }));

  return function apiDeleteOrganizationSubsidiary(_x15) {
    return _ref15.apply(this, arguments);
  };
}();
export var apiQueryOrganizationSubsidiaryList = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(payload) {
    var _res$data3, res;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            _context16.next = 3;
            return api.get("/organization_subsidiary/organization/".concat(payload.organization_id, "?").concat(qs.stringify(payload)));

          case 3:
            res = _context16.sent;

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data)) {
              res.data.data.forEach(function (item) {
                item.value = item.id;
                item.label = item.name;
              });
            }

            return _context16.abrupt("return", [res.data]);

          case 8:
            _context16.prev = 8;
            _context16.t0 = _context16["catch"](0);
            return _context16.abrupt("return", handleRequestError(_context16.t0, payload));

          case 11:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 8]]);
  }));

  return function apiQueryOrganizationSubsidiaryList(_x16) {
    return _ref16.apply(this, arguments);
  };
}();
export var apiPatchOrganizationSupplierCompaniesAndParentSubsidiary = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            _context17.next = 3;
            return api.patch("/msp/supplier/".concat(payload.supplier_id, "/organization_subsidiary_company_binding"), payload);

          case 3:
            res = _context17.sent;
            return _context17.abrupt("return", [res.data]);

          case 7:
            _context17.prev = 7;
            _context17.t0 = _context17["catch"](0);
            return _context17.abrupt("return", handleRequestError(_context17.t0, payload));

          case 10:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 7]]);
  }));

  return function apiPatchOrganizationSupplierCompaniesAndParentSubsidiary(_x17) {
    return _ref17.apply(this, arguments);
  };
}();